export default {
	authorized: false,
	session_id: 0,
	headerDetails: { emulateJSON: true },
	objAuthorize: [],
	jwtAuth: '',
	globalSnackColor: '',
	globalSnackDisplay: false,
	globalSnackMessage: '',
	globalModalTitle: 'Default Title',
	globalModalComponent: 'default',
	globalModalState: false,
	globalModalParams: [],
	spineToken: '',
	spinePriceList: [],
	runAdd: false,
	sideProps: false,
  isLoading: false,
  quotePagination: 1,
  setManufacturer: '0'
}
